unit Pristanisce;

interface

uses
  System.SysUtils, System.Variants, System.Classes, Web,
  Vcl.Graphics, Vcl.Controls, Vcl.Forms, Vcl.Dialogs, Vcl.StdCtrls, TerminalForm,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.Controls, WEBLib.Grids, WEBLib.DBCtrls, WEBLib.Forms,
  XData.Web.Connection, Vcl.Grids, WEBLib.Lists, WEBLib.CDS;

type
  TfrmPristanisce = class(TTerminalForm)
    tmrFind: TTimer;
    wdsView: TXDataWebDataSet;
    dsView: TDataSource;
    btnSelect: TButton;
    btnCancel: TButton;
    lblNaslov: TLabel;
    WebDBListControl1: TDBListControl;
    procedure edtFilterChange(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure btnCancelClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure btnSelectClick(Sender: TObject);
    procedure gridViewGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure WebDBListControl1ItemClick(Sender: TObject; AListItem: TListItem);
  private
    { Private declarations }
    procedure ApplyTheme(Dark: boolean); reintroduce;
    procedure SelectClick(event: TJSEvent);
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

implementation

{$R *.dfm}

uses Client.Core, Main;

procedure TfrmPristanisce.ApplyTheme(Dark: boolean);
begin
  inherited;
end;

procedure TfrmPristanisce.btnCancelClick(Sender: TObject);
begin
  frmMain.ShowPrevious;
end;

procedure TfrmPristanisce.btnSelectClick(Sender: TObject);
begin
  inherited;
  modMain.NastaviPristanisce(wdsView.FieldByName('ID').AsInteger, wdsView.FieldByName('Naziv').AsString);
  Log('modMain.PristanisceId: '+modMain.PristanisceId.ToString);
  frmMain.ShowCheck('');
end;

procedure TfrmPristanisce.edtFilterChange(Sender: TObject);
begin
  tmrFind.Enabled := false;
  tmrFind.Enabled := true;
end;

procedure TfrmPristanisce.gridViewGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
//var el: TJSHTMLElement;
begin
  inherited;
(*  if (ACol = 1) and (ARow >= 0) then begin
    el := TJSHTMLElement(document.createElement('INPUT'));
    el['type'] := 'BUTTON';
    el['value'] := ' Izberi';
    el['data'] := ARow.ToString;
    el.addEventListener('click',@SelectClick);
//    el.style.setProperty('width','80px');
//    el.style.setProperty('height','80px');
//    el.style.setProperty('font-size','large');
//    el.innerHTML := '<i class="material-icons" style="font-size: 20px">close</i>';
    el.className := 'btn btn-link px-2';
    AElement.element.appendChild(el);
  end; *)
end;

procedure TfrmPristanisce.SelectClick(event: TJSEvent);
//var SelRow: integer;
begin
(*  SelRow := StrToIntDef(TJSHTMLElement(event.target)['data'], 0);

  wdsView.RecNo := SelRow+1;

  btnSelect.Click;   *)
end;

procedure TfrmPristanisce.WebDBListControl1ItemClick(Sender: TObject;
  AListItem: TListItem);
begin
  inherited;
  wdsView.Locate('Naziv', AListItem.Text, []);

end;

procedure TfrmPristanisce.WebFormCreate(Sender: TObject);
begin
  modMain.PristanisceId := 0;

  wdsView.Close;
  wdsView.QueryString := '$orderby=Naziv';
  wdsView.Load;
end;

procedure TfrmPristanisce.WebFormShow(Sender: TObject);
begin
  inherited;
  ApplyTheme(frmMain.DarkMode);
end;

procedure TfrmPristanisce.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblNaslov := TLabel.Create('lblNaslov');
  btnSelect := TButton.Create('btnSelect');
  btnCancel := TButton.Create('btnCancel');
  WebDBListControl1 := TDBListControl.Create('gridView');
  tmrFind := TTimer.Create(Self);
  wdsView := TXDataWebDataSet.Create(Self);
  dsView := TDataSource.Create(Self);

  lblNaslov.BeforeLoadDFMValues;
  btnSelect.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  WebDBListControl1.BeforeLoadDFMValues;
  tmrFind.BeforeLoadDFMValues;
  wdsView.BeforeLoadDFMValues;
  dsView.BeforeLoadDFMValues;
  try
    Align := alClient;
    Color := clBtnFace;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lblNaslov.SetParentComponent(Self);
    lblNaslov.Name := 'lblNaslov';
    lblNaslov.Left := 24;
    lblNaslov.Top := 16;
    lblNaslov.Width := 51;
    lblNaslov.Height := 13;
    lblNaslov.Caption := 'Pristani'#353#269'a';
    lblNaslov.Color := clBtnFace;
    lblNaslov.ElementFont := efCSS;
    lblNaslov.ElementPosition := epIgnore;
    lblNaslov.HeightStyle := ssAuto;
    lblNaslov.HeightPercent := 100.000000000000000000;
    lblNaslov.WidthStyle := ssAuto;
    lblNaslov.WidthPercent := 100.000000000000000000;
    btnSelect.SetParentComponent(Self);
    btnSelect.Name := 'btnSelect';
    btnSelect.AlignWithMargins := True;
    btnSelect.Left := 281;
    btnSelect.Top := 634;
    btnSelect.Width := 165;
    btnSelect.Height := 107;
    btnSelect.ChildOrder := 1;
    btnSelect.ElementFont := efCSS;
    btnSelect.ElementPosition := epIgnore;
    btnSelect.HeightStyle := ssAuto;
    btnSelect.HeightPercent := 100.000000000000000000;
    btnSelect.WidthStyle := ssAuto;
    btnSelect.WidthPercent := 100.000000000000000000;
    SetEvent(btnSelect, Self, 'OnClick', 'btnSelectClick');
    btnCancel.SetParentComponent(Self);
    btnCancel.Name := 'btnCancel';
    btnCancel.AlignWithMargins := True;
    btnCancel.Left := 164;
    btnCancel.Top := 633;
    btnCancel.Width := 111;
    btnCancel.Height := 109;
    btnCancel.Cancel := True;
    btnCancel.ChildOrder := 1;
    btnCancel.ElementFont := efCSS;
    btnCancel.ElementPosition := epIgnore;
    btnCancel.HeightStyle := ssAuto;
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.WidthStyle := ssAuto;
    btnCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    WebDBListControl1.SetParentComponent(Self);
    WebDBListControl1.Name := 'WebDBListControl1';
    WebDBListControl1.Left := 8;
    WebDBListControl1.Top := 55;
    WebDBListControl1.Width := 421;
    WebDBListControl1.Height := 258;
    WebDBListControl1.HeightStyle := ssAuto;
    WebDBListControl1.HeightPercent := 100.000000000000000000;
    WebDBListControl1.WidthPercent := 100.000000000000000000;
    WebDBListControl1.AutoSelect := True;
    WebDBListControl1.ChildOrder := 4;
    WebDBListControl1.DefaultItemClassName := 'list-group-item fs-4';
    WebDBListControl1.DefaultItemLinkClassName := 'list-group-link';
    WebDBListControl1.ElementFont := efCSS;
    WebDBListControl1.ElementListClassName := 'list-group';
    WebDBListControl1.Items.Clear;
    with WebDBListControl1.Items.Add do
    begin
      ItemClassName := 'list-group-item fs-4';
      LinkClassName := 'list-group-link';
      Text := 'Item 0';
    end;
    with WebDBListControl1.Items.Add do
    begin
      ItemClassName := 'list-group-item fs-4';
      LinkClassName := 'list-group-link';
      Text := 'Item 1';
    end;
    with WebDBListControl1.Items.Add do
    begin
      ItemClassName := 'list-group-item fs-4';
      LinkClassName := 'list-group-link';
      Text := 'Item 2';
    end;
    WebDBListControl1.Style := lsListGroup;
    SetEvent(WebDBListControl1, Self, 'OnItemClick', 'WebDBListControl1ItemClick');
    WebDBListControl1.ListField := 'Naziv';
    WebDBListControl1.ListSource := dsView;
    tmrFind.SetParentComponent(Self);
    tmrFind.Name := 'tmrFind';
    tmrFind.Enabled := False;
    tmrFind.Interval := 2000;
    tmrFind.Left := 108;
    tmrFind.Top := 104;
    wdsView.SetParentComponent(Self);
    wdsView.Name := 'wdsView';
    wdsView.EntitySetName := 'Pristanisce';
    wdsView.Connection := modMain.connServer;
    wdsView.Left := 104;
    wdsView.Top := 256;
    dsView.SetParentComponent(Self);
    dsView.Name := 'dsView';
    dsView.AutoEdit := False;
    dsView.DataSet := wdsView;
    dsView.Left := 104;
    dsView.Top := 312;
  finally
    lblNaslov.AfterLoadDFMValues;
    btnSelect.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    WebDBListControl1.AfterLoadDFMValues;
    tmrFind.AfterLoadDFMValues;
    wdsView.AfterLoadDFMValues;
    dsView.AfterLoadDFMValues;
  end;
end;

end.
